<div>
    <ev-time-period-filter
        [rangeToMonthList]="rangeToMonthListValue"
        [defaultValue]="defaultValue"
        [selectedPeriod]="selectedValue"
        (onTimePeriodChange)="onChange($event)"
        [reset]="reset()"
    ></ev-time-period-filter>
</div>
